// eslint-disable-next-line camelcase
const { enable_console } = window.TaoConsole || { 'enable_console': false };

const TaoConsole = {
	log() {},
	debug() {},
	error() {},
	warn() {},
};

// eslint-disable-next-line camelcase
TaoConsole.enable_console = enable_console || false;

TaoConsole.log = function() {
	// eslint-disable-next-line
	TaoConsole.enable_console && console && console.log.apply( console, Array.prototype.slice.call( arguments, 0 ) );
};
TaoConsole.debug = function() {
	// eslint-disable-next-line
	TaoConsole.enable_console && console && console.debug.apply( console, Array.prototype.slice.call( arguments, 0 ) );
};
TaoConsole.error = function() {
	// eslint-disable-next-line
	TaoConsole.enable_console && console && console.error.apply( console, Array.prototype.slice.call( arguments, 0 ) );
};
TaoConsole.warn = function() {
	// eslint-disable-next-line
	TaoConsole.enable_console && console && console.warn.apply( console, Array.prototype.slice.call( arguments, 0 ) );
};

export default TaoConsole;
